// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rp-1","left":"styles_left__30JO7","desktopActions":"styles_desktopActions__CQUf_","title":"styles_title__3KdiM"};